import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { AllSpaceText } from '../AllSpaceText';
import { splitPhraseIntoTwoLines } from '../utils/splitPhraseIntoTwoLines';
import * as styles from './MortgageAnnotations.css';
import { EMortgageAnnotationHeightPercent } from '../../enums/EMortgageAnnotationHeightPercent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MIN_LETTER_SPACING = -1.5;
export var MortgageAnnotations = function MortgageAnnotations(_ref) {
  var mortgageWarning = _ref.mortgageWarning,
    _ref$splitMortgageWar = _ref.splitMortgageWarning,
    splitMortgageWarning = _ref$splitMortgageWar === void 0 ? 'auto' : _ref$splitMortgageWar,
    mortgageTermsWarning = _ref.mortgageTermsWarning,
    _ref$splitMortgageTer = _ref.splitMortgageTermsWarning,
    splitMortgageTermsWarning = _ref$splitMortgageTer === void 0 ? 'auto' : _ref$splitMortgageTer,
    height = _ref.height;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    splitMortgageWarningForce = _React$useState2[0],
    setSplitMortgageWarningForce = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    splitMortgageTermsWarningForce = _React$useState4[0],
    setSplitMortgageTermsWarningForce = _React$useState4[1];
  var mortgageWarningView = React.useMemo(function () {
    if (!mortgageWarning) {
      return null;
    }
    if (splitMortgageWarning === true || splitMortgageWarning === 'force' || splitMortgageWarning === 'auto' && splitMortgageWarningForce) {
      return splitPhraseIntoTwoLines(mortgageWarning).map(function (text, index) {
        return /*#__PURE__*/_jsx(AllSpaceText, {
          text: text,
          height: height,
          heightPercent: EMortgageAnnotationHeightPercent.Half
        }, index);
      });
    }
    return /*#__PURE__*/_jsx(AllSpaceText, {
      text: mortgageWarning,
      height: height,
      heightPercent: EMortgageAnnotationHeightPercent.Default,
      onAllSpaceCalculated: function onAllSpaceCalculated(_ref2) {
        var letterSpacing = _ref2.letterSpacing;
        var demount = false;
        if (splitMortgageWarning === 'auto' && letterSpacing < MIN_LETTER_SPACING) {
          setSplitMortgageWarningForce(true);
          demount = true;
        }
        return demount;
      }
    });
  }, [height, mortgageWarning, splitMortgageWarning, splitMortgageWarningForce]);
  var mortgageTermsWarningView = React.useMemo(function () {
    if (!mortgageTermsWarning) {
      return null;
    }
    if (splitMortgageTermsWarning === true || splitMortgageTermsWarning === 'force' || splitMortgageTermsWarning === 'auto' && splitMortgageTermsWarningForce) {
      return splitPhraseIntoTwoLines(mortgageTermsWarning).map(function (text, index) {
        return /*#__PURE__*/_jsx(AllSpaceText, {
          text: text,
          height: height,
          heightPercent: EMortgageAnnotationHeightPercent.Half
        }, index);
      });
    }
    return /*#__PURE__*/_jsx(AllSpaceText, {
      text: mortgageTermsWarning,
      height: height,
      heightPercent: EMortgageAnnotationHeightPercent.Default,
      onAllSpaceCalculated: function onAllSpaceCalculated(_ref3) {
        var letterSpacing = _ref3.letterSpacing;
        var demount = false;
        if (splitMortgageTermsWarning === 'auto' && letterSpacing < MIN_LETTER_SPACING) {
          setSplitMortgageTermsWarningForce(true);
          demount = true;
        }
        return demount;
      }
    });
  }, [height, mortgageTermsWarning, splitMortgageTermsWarning, splitMortgageTermsWarningForce]);
  if (!mortgageWarningView && !mortgageTermsWarningView) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [mortgageWarningView, mortgageTermsWarningView]
  });
};